export function Business(){

return (

<div className="space-y-6">


<h1 className="text-3xl font-bold">
💎 商业中心
</h1>


<p className="text-slate-400">
PromptOS 未来商业化入口
</p>


<div className="grid md:grid-cols-3 gap-5">


<div className="border rounded-xl p-6">

<h2>
免费版
</h2>

<p>
基础Prompt生成
</p>

</div>


<div className="border rounded-xl p-6">

<h2>
Pro会员
</h2>

<p>
高级模板
AI工作流
</p>

</div>


<div className="border rounded-xl p-6">

<h2>
企业版
</h2>

<p>
团队Prompt管理
</p>

</div>


</div>


</div>

)

}